import idx from "idx";
import React from "react";
import styled from "styled-components";
import { IOrganization } from "../../../reducers/course-author/types";
import { store } from "../../../store";
import colors from "../../../styles/colors";
import Pagination from "../../utils/Pagination";
import { Organization } from "./Organization";

const SelectOrganizationTitle = styled.div`
  color: ${colors.darkblue};
`;
export class OrganizationPagination extends Pagination<IOrganization> {}

export interface ISelectOrganizationProps {
  selectedOrganization: IOrganization | null;
  organizations: IOrganization[];
  childrenLookup: { [k: string]: IOrganization[] };
  onOrganizationClick: (org: IOrganization) => void;
}

export const SelectOrganizationPage: React.SFC<ISelectOrganizationProps> = props => {
  const ownerOrganizationId = idx(store.getState(), ({ App }) => App._.user.ownerOrganizationId) || "";
  const organizations = props.organizations.filter(org => org.organizationId === ownerOrganizationId);

  return (
    <div>
      <SelectOrganizationTitle>Select Organization</SelectOrganizationTitle>
      {organizations.map((org: IOrganization) => (
        <Organization
          onClick={props.onOrganizationClick}
          key={org.organizationId}
          selectedOrganization={props.selectedOrganization}
          organization={org}
          childrenLookup={props.childrenLookup}
        />
      ))}
    </div>
  );
};
